export const translationHashes = {
  "de-DE": "0f9c3790",
  "en-CA": "735bc30a",
  "en-GB": "9050c86d",
  "en-US": "921dd595",
  "es-ES": "f06d9bc3",
  "es-US": "df7f55ad",
  "formattings": "a7aab157",
  "fr-CA": "b3e2ba2a",
  "nl-NL": "d050c5ab",
  "sv-SE": "fc87d1f2"
} as {[lang: string]: string};